import { Typography } from "@mui/material";
import { Row } from "v2/components/base/Flex/ui";
import withAppSideBarLogout from "../../hocs/withAppSideBarLogout";
import withAppSideBarProfileName from "../../hocs/withAppSideBarProfileName";

const AppSideBarProfileSectionUserName = ({ tgUserName, ...props }: { tgUserName: string }) => {
  return (
    <Row type="cc" {...props}>
      <Typography variant="mobile-display-xs" color="brand.primary">
        {tgUserName}
      </Typography>
    </Row>
  );
};

const AppSideBarProfileSectionLogout = ({
  onClickLogout,
  ...props
}: {
  onClickLogout: () => void;
}) => {
  return (
    <Row type="cc" sx={{ cursor: "pointer" }} {...props}>
      <Typography variant="mobile-body-m-heavy" color="text.secondary">
        Logout
      </Typography>
    </Row>
  );
};

const AppSideBarProfile = {
  UserName: withAppSideBarProfileName(AppSideBarProfileSectionUserName),
  Logout: withAppSideBarLogout(AppSideBarProfileSectionLogout),
};

export default AppSideBarProfile;
